import React from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "@/components/ui/dialog";
import { fmt } from "@/pages/admin/utils/format";

const RescheduleModal = ({ reschedule, setReschedule, closeReschedule, submitReschedule }) => (
        <Dialog
          open={!!reschedule.target}
          onOpenChange={(o) => { if (!o) closeReschedule(); }}
        >
          <DialogContent dir="rtl" className="max-w-md" data-testid="admin-reschedule-modal">
            <DialogHeader>
              <DialogTitle className="font-heading text-xl text-[#0A4D3C]">
                ترحيل الموعد
              </DialogTitle>
              <DialogDescription className="text-sm text-[#5E5C58]">
                اختر تاريخًا ووقتًا جديدًا لجلسة العميل. سيتم إرسال إشعار البريد تلقائيًا.
              </DialogDescription>
            </DialogHeader>

            {reschedule.target && (
              <div className="mb-2 rounded-xl bg-[#F6F4EE] border border-[#E5E1D8] p-3 text-xs text-[#5E5C58]">
                <div>
                  <span>العميل: </span>
                  <strong className="text-[#222222]">
                    {reschedule.target.user_name || "—"}
                  </strong>
                </div>
                <div>
                  <span>الخدمة: </span>
                  <strong className="text-[#222222]">
                    {reschedule.target.service_title_ar}
                  </strong>
                </div>
                <div>
                  <span>الموعد الحالي: </span>
                  <strong className="text-[#222222]">
                    {fmt(reschedule.target.slot_iso)}
                  </strong>
                </div>
              </div>
            )}

            <div className="grid grid-cols-2 gap-3">
              <div>
                <label className="block text-xs text-[#5E5C58] mb-1">التاريخ الجديد</label>
                <Input
                  type="date"
                  data-testid="reschedule-date-input"
                  value={reschedule.date}
                  onChange={(e) => setReschedule((r) => ({ ...r, date: e.target.value }))}
                />
              </div>
              <div>
                <label className="block text-xs text-[#5E5C58] mb-1">الوقت الجديد</label>
                <Input
                  type="time"
                  data-testid="reschedule-time-input"
                  value={reschedule.time}
                  step={3600}
                  onChange={(e) => setReschedule((r) => ({ ...r, time: e.target.value }))}
                />
              </div>
            </div>

            <div className="mt-3">
              <label className="block text-xs text-[#5E5C58] mb-1">
                ملاحظة للعميل (اختياري)
              </label>
              <textarea
                data-testid="reschedule-note-input"
                rows={3}
                value={reschedule.note}
                onChange={(e) => setReschedule((r) => ({ ...r, note: e.target.value }))}
                className="w-full rounded-xl border border-[#E5E1D8] bg-white px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-[#0A4D3C]"
                placeholder="مثال: نأسف للتغيير، تم الترحيل بناءً على طلبكم..."
              />
            </div>

            <DialogFooter className="gap-2">
              <Button
                type="button"
                variant="outline"
                className="rounded-full"
                onClick={closeReschedule}
                data-testid="reschedule-cancel-btn"
                disabled={reschedule.saving}
              >
                إلغاء
              </Button>
              <Button
                type="button"
                className="rounded-full bg-[#0A4D3C] hover:bg-[#063A2D] text-white"
                onClick={submitReschedule}
                data-testid="reschedule-confirm-btn"
                disabled={reschedule.saving || !reschedule.date || !reschedule.time}
              >
                {reschedule.saving ? "جاري الترحيل..." : "تأكيد الترحيل"}
              </Button>
            </DialogFooter>
          </DialogContent>
        </Dialog>
);

export { RescheduleModal };
